import { useState, useMemo, useEffect } from "react";
import { FormulaDisplay } from "./LineageFormula";
import { ParsedMetric } from "../Metrics.types";
import { AccountLabelFetch } from "./AccountLabelFetch";
import { SourceFile } from "./SourceFile";

export function MetricLineage({
    metric,
    onSourceSelect,
}: {
    metric: ParsedMetric;
    onSourceSelect: () => void;
}) {
    // Find the first value with metadata (clickable value)
    const firstClickableRef = useMemo(() => {
        const firstWithMeta = metric.values.find((v) => v.meta);
        return firstWithMeta?.ref || "$0";
    }, [metric.values]);

    const [selectedRef, setSelectedRef] = useState<string>(firstClickableRef);

    // Reset selection to first value when metric changes
    useEffect(() => {
        setSelectedRef(firstClickableRef);
    }, [metric, firstClickableRef]);

    const selectedValue = metric.values.find(
        (value) => value.ref === selectedRef,
    );
    const fileId = selectedValue?.meta?.dataAssetId;
    const accountId = selectedValue?.meta?.accountId;

    return (
        <div className="mt-1 flex flex-col gap-2">
            <FormulaDisplay
                metric={metric as ParsedMetric}
                onValueClick={(value) => {
                    console.log(value);
                    setSelectedRef(value.ref);
                }}
                selectedRef={selectedRef}
            />
            {accountId && <AccountLabelFetch accountId={accountId} />}
            {fileId && <SourceFile fileId={fileId} onSelect={onSourceSelect} />}
        </div>
    );
}
